import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { Device } from "../../../components/device";
import Calendar from "../Calendar/Calendar";
import ShowsGrid from "../../components/Show/ShowsGrid";
import { SecondaryButton } from "../../components/UI/Button/Button";
import Icon from "../../components/Icon/Icon";
import MobileFilter from "../../components/Filter/MobileFilter";
import WebFilter from "../Filter/WebFilter";
import { getFilteredShows } from "../../../store/shows";
import { AppState } from "../../../store";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

const inAnimation = keyframes`
    from {opacity: 0; transform: translateY(-1rem);}
    to {opacity: 1; transform: translateY(0);}
`;

const WhatsOnWrap = styled.section`
  position: relative;
`;

const WhatsOnFilters = styled.div`
  position: relative;
  .whatson-filter-btn {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    ${Device.tablet} {
      display: none;
    }
    &__count {
      position: absolute;
      right: 1rem;
      padding: 3px 3px 2px 3px;
      background-color: var(--color-gray-20, #ebebeb);
      line-height: 1;
      min-width: 12px;
      min-height: 12px;
    }
  }
`;

const WhatsOnNav = styled.nav`
  display: flex;
  overflow-x: scroll;
  margin-bottom: 1rem;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  overflow: hidden;
  ${Device.tablet} {
    overflow-x: auto;
  }
  button {
    font-weight: bold;
    color: currentColor;
    cursor: pointer;
    display: inline-block;
    font-size: 1rem;
    letter-spacing: 0.075rem;
    text-decoration: none;
    overflow: hidden;
    user-select: none;
    text-transform: uppercase;
    width: 50%;
    opacity: 0.25;
    padding-top: 1em;
    padding-bottom: 1em;
    line-height: 1;
    transition: opacity 0.3s;
    position: relative;
    &:after {
      content: "";
      height: 2px;
      width: 100%;
      background-color: currentColor;
      display: inline-block;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    &:focus {
      outline: none;
    }
    @media only screen and (max-width: 320px) {
      font-size: var(--text-small, 13px);
    }
    ${Device.tablet} {
      font-size: 2rem;
      padding-bottom: 1.4rem;
      &:after {
        height: 3px;
      }
    }
    ${Device.laptop} {
      font-size: 2.75rem;
      //padding-bottom: 1.4rem;
      letter-spacing: 0.2rem;
      &:after {
        height: 4px;
      }
    }
    &:hover,
    &.active {
      opacity: 1;
    }
  }
`;

const WhatsOnContent = styled.div`
  position: relative;
  transition: all 0.4s;
`;

const WhatsOnPanel = styled.div`
  padding: 1rem 0;
  transform: translateY(-1rem);
  animation: ${inAnimation} 0.5s forwards;
`;

interface WhatsOnProps {
  buyOnClick: (eventNo: number, showNo?: number) => void;
}

const WhatsOn: React.FC<WhatsOnProps & WhatsOnStateProps> = (props) => {
  const [tabActive, setTabActive] = React.useState(1);

  const setTabActiveHandler = (tab: number) => () => {
    setTabActive(tab);
  };

  const history = useHistory();

  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#kalender") {
      setTabActive(2);
    }
  }, []);

  useEffect(() => {
    if (tabActive === 2) {
      history.replace("#kalender");
    } else {
      history.replace(history.location.pathname);
    }
  }, [tabActive, history]);

  const activeMenuHandler = (tab: number): string => {
    if (tab === tabActive) {
      return "active";
    }
    return "";
  };

  //Mobile filter component
  const [filterDrawer, setFilterDrawer] = useState(false);
  // const [currentDropdown, setCurrentDropdown] = useState(-1);
  // const [mobileColor, setMobileColor] = useState("");
  // const [currentArr, setCurrentArr] = useState<IMenuItem[]>([]);

  const openDrawerFilter = () => {
    setFilterDrawer(true);
  };

  const closeFilterDrawer = () => {
    setFilterDrawer(false);
  };

  return (
    <WhatsOnWrap>
      <WhatsOnNav className="font-josefin-sans">
        <button
          onClick={setTabActiveHandler(1)}
          className={activeMenuHandler(1)}
        >
          Forestillinger
        </button>
        <button
          onClick={setTabActiveHandler(2)}
          className={activeMenuHandler(2)}
        >
          Kalender
        </button>
      </WhatsOnNav>

      <WhatsOnFilters>
        <SecondaryButton
          onClick={openDrawerFilter}
          className="whatson-filter-btn"
        >
          <Icon name="filter" className="w-4 h-4 mr-2" />
          Filtrer
          {/* <span className="whatson-filter-btn__count text-xSmall">3</span> */}
        </SecondaryButton>

        <MobileFilter
          openDrawer={openDrawerFilter}
          closeDrawer={closeFilterDrawer}
          drawer={filterDrawer}
          zIndex={105}
        />

        <WebFilter />
      </WhatsOnFilters>

      <WhatsOnContent>
        {tabActive === 1 ? (
          <WhatsOnPanel>
            <ShowsGrid
              shows={props.filteredShows}
              columns={3}
              buyOnClick={props.buyOnClick}
            />
          </WhatsOnPanel>
        ) : (
          <WhatsOnPanel>
            <Calendar
              shows={props.filteredShows}
              buyOnClick={props.buyOnClick}
            />
          </WhatsOnPanel>
        )}
      </WhatsOnContent>
    </WhatsOnWrap>
  );
};

const mapStateToProps = (state: AppState) => ({
  filteredShows: getFilteredShows(state.shows.shows, state.shows.filters),
});

type WhatsOnStateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(WhatsOn);
